<template>
  <CallPlanningLayout>
    <div class="hvh-flex space-between align-center">
      <h4>{{ user?.email }}</h4>
      <v-btn class="hvh-btn hvh-btn--primary button ml-5" :class="{ disabled: hash === currentHash }" flat large @click="saveUserTerritories">Save</v-btn>
    </div>
    <CallPlanningAddTerritory class="mt-5" text="Manager" v-model="managersTerritories" :regions="regions" :territories="territories" />
    <CallPlanningAddTerritory class="mt-5" text="User" v-model="usersTerritories" :regions="regions" :territories="territories" />
    <Loader v-if="isLoading" />
  </CallPlanningLayout>
</template>
<script>
import axios from '../../axios';
import CallPlanningLayout from '../../components/callPlanning/CallPlanningLayout.vue';
import CallPlanningAddTerritory from '../../components/callPlanning/CallPlanningAddTerritory.vue';
import Loader from '../../components/common/loader/Loader.vue';
import { errorDebug, hashCode, toFormData } from '../../libraries/common';
import DataTable from '../../components/common/dataTable/DataTable.vue';
import Th from '../../components/common/dataTable/Th.vue';
import Test from '../test/Test.vue';
export default {
  components: { Loader, CallPlanningLayout, CallPlanningAddTerritory, DataTable, Th, Test, },
  data() {
    return {
      userEmail: null,
      user: null,
      managersTerritories: [],
      usersTerritories: [],
      isLoading: false,
      isLoadingUsers: false,
      regions: [],
      territories: [],
      users: {},
      hash: null,
      brand: null,
    }
  },
  computed: {
    brandId() {
      return this.$route.params.brandId;
    },
    userId() {
      return this.$route.params.userId;
    },
    currentHash() {
      return this.calculateHash();
    },
    allUsers() {
      var { users, managers } = this.users;
      return (managers || [])
        .map(f => ({ ...f, role: 'Manager' }))
        .concat((users || []).map(f => ({ ...f, role: 'User' })));
    },
  },
  methods: {
    calculateHash() {
      return hashCode({
        managersTerritories: this.managersTerritories,
        usersTerritories: this.usersTerritories,
      });
    },
    getUserTerritories() {
      this.isLoading = true;
      axios.get(`/api/CallPlanning/${this.brandId}/Admin/Users/${this.userId}`)
        .then(({ data }) => {
          this.user = data.user;
          this.managersTerritories = data.managersTerritories;
          this.usersTerritories = data.usersTerritories;
          this.hash = this.calculateHash();
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    saveUserTerritories() {
      this.isLoading = true;
      var data = {
        managersTerritories: this.managersTerritories,
        usersTerritories: this.usersTerritories,
      };
      axios.post(`/api/CallPlanning/${this.brandId}/Admin/Users/${this.userId}`, toFormData(data))
        .then(({ data }) => {
          this.managersTerritories = data.managersTerritories;
          this.usersTerritories = data.usersTerritories;
          this.hash = this.calculateHash();
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    getTerritories() {
      return axios.get(`/api/CallPlanning/${this.brandId}/Admin/Territories`)
        .then(({ data }) => {
          this.regions = data.regions;
          this.territories = data.territories;
        })
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    getUsers() {
      this.isLoadingUsers = true;
      axios.get(`/api/CallPlanning/${this.brandId}/Admin/GetUsers`)
        .then(({ data }) => this.users = data)
        .catch(errorDebug)
        .then(() => this.isLoadingUsers = false);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCallPlanningAdmin'] = this;

    this.hash = this.calculateHash();
    this.getTerritories();
    this.getUserTerritories();
  },
}
</script>
